module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_v_brown.2f126d5a.png";